// Top-level safety net.
//
// Layer 2 of the "no more 'X is not a function' surprises" defense built
// after iter-61 found a callback prop mismatch crashed AddChildEnrollmentForm.
//
// Catches any uncaught React render error, shows a friendly recovery page
// (instead of a blank white screen), and POSTs the error details to
// /api/client-error so the main agent can debug remotely instead of
// playing 20 questions with the director.

import React from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default class ErrorBoundary extends React.Component {
  state = { error: null, info: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    this.setState({ info });
    try {
      axios.post(`${BACKEND_URL}/api/client-error`, {
        message: String(error?.message || error),
        stack: String(error?.stack || ""),
        component_stack: String(info?.componentStack || ""),
        url: window.location.href,
        user_agent: navigator.userAgent,
      }).catch(() => { /* never let logging block recovery */ });
    } catch { /* paranoia */ }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" style={{
        minHeight: "100vh", display: "grid", placeItems: "center",
        background: "#fafaf9", padding: 40, fontFamily: "system-ui",
      }}>
        <div style={{ maxWidth: 520, textAlign: "center" }}>
          <div style={{
            fontSize: 56, color: "#047857", marginBottom: 12,
          }}>⚠️</div>
          <h1 style={{ fontSize: 28, fontWeight: 600, color: "#1c1917", marginBottom: 12 }}>
            Something glitched.
          </h1>
          <p style={{ color: "#57534e", marginBottom: 24, lineHeight: 1.6 }}>
            ChildCheck just caught an error before it broke the page. The technical details
            have been sent to the team — you can reload and keep working.
          </p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
            <button
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 20px", borderRadius: 12,
                background: "#047857", color: "white", border: 0,
                fontWeight: 600, cursor: "pointer",
              }}
            >Reload the page</button>
            <button
              data-testid="error-boundary-home"
              onClick={() => { window.location.href = "/dashboard"; }}
              style={{
                padding: "10px 20px", borderRadius: 12,
                background: "white", color: "#57534e",
                border: "1px solid #d6d3d1", fontWeight: 600, cursor: "pointer",
              }}
            >Back to dashboard</button>
          </div>
          <pre style={{
            marginTop: 28, fontSize: 11, color: "#a8a29e",
            textAlign: "left", whiteSpace: "pre-wrap",
            background: "#f5f5f4", padding: 12, borderRadius: 8,
            maxHeight: 180, overflow: "auto",
          }}>{String(this.state.error?.message || this.state.error)}</pre>
        </div>
      </div>
    );
  }
}
